/* eslint-disable
    no-var,
    one-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate from 'immutability-helper';
import _ from 'underscore';

import tokenizer from 'notebook/tables/excess/Tokenizer';
import {
  Table,
  Cell,
  COLUMN_FIELD_DEFAULTS,
  PastedCell,
  TableColumnType,
  TableOpDiff,
  ColumnConstraint,
} from 'notebook/tables/TableConstants';
import TableUtil from 'notebook/tables/TableUtil';
import {formatTypedValue, isTypedValueEmpty} from 'notebook/tables/typed-values/DataTypes';

import {EvaluatedCell, EvaluatedTable, RelativeCellAddress} from '../Evaluator';

function relToAbsCell(cell: PastedCell, anchor: RelativeCellAddress): Cell {
  const newCell = {
    ...cell,
    text:
      cell.formula != null
        ? tokenizer.toAbsoluteFormula(cell.formula, anchor)
        : cell.text != null
          ? cell.text
          : '',
  };
  delete newCell.formula;
  return newCell;
}

/**
  Convert the cell to a more appropriate pasted value based on the destination column constraint.
*/
function getPasteTypeConvertedCell(cell: PastedCell, columnConstraint: ColumnConstraint | null): PastedCell {
  // When pasting typedValue from other cell into a STRING type column cell, convert the data type.
  if (columnConstraint?.columnDefinition?.type === TableColumnType.STRING) {
    if (!cell.text && cell.typedValue) {
      cell.text = formatTypedValue(cell.typedValue);
      cell.typedValue = null;
    }
  }
  // Avoid copy and pasting empty typed values that are invisibly the wrong type between columns of different types.
  if (cell.typedValue && isTypedValueEmpty(cell.typedValue)) {
    cell.text = cell.text != null ? cell.text : '';
    cell.typedValue = null;
  }
  return cell;
}

/**
 * Pastes `cells` into `table` at position (`minI`, `minJ`). Extends table as necessary to accomodate pasted
 * cells that would otherwise overflow the dimensions of `table`.
 * @param  {Object} table        [description]
 * @param  {Array} computedTable 2D array containing the evaluated cells of the table,
                                  containing the results of formulas.
 * @param  {Array} cells         2D Array of relative cells to paste.
 * @param  {Number} minI         The top coordinate at which to paste
 * @param  {Number} minJ         The left coordinate at which to paste
 * @return {Object}              The result of the paste, consisting of:
 *                                  table: new table
 *                                  box: the region that was pasted into as {minI, maxI, minJ, maxJ}
 */
function paste(
  table: Table,
  computedTable: EvaluatedTable,
  cells: Array<Array<PastedCell>>,
  minI: number,
  minJ: number,
  preserveMergedCells: boolean = false
): {table: Table; box: {minI: number; maxI: number; minJ: number; maxJ: number}; tableOp: TableOpDiff} {
  let j, i;
  const rowCount = cells.length;
  const colCount = cells[0].length;
  const [height, width] = TableUtil.getDimensions(table);
  const fullColCount = Math.max(colCount + minJ, width);
  const fullRowCount = Math.max(rowCount + minI, height);
  const fillerFor = (count: number): Array<Cell> =>
    __range__(0, fullColCount - count, false).map((j) => ({text: ''}));
  const columnConstraints = table.columnConstraints;
  const tableOp: TableOpDiff = {type: 'upsert-cells', cells: []};
  if (fullColCount > width) {
    tableOp.newColIndexes = Array.from({length: fullColCount - width}, (_, i) => i + width);
  }
  if (fullRowCount > height) {
    tableOp.newRowIndexes = Array.from({length: fullRowCount - height}, (_, i) => i + height);
  }
  const newCells = (() => {
    let asc, end;
    const result = [];
    // eslint-disable-next-line benchlint/disallow-comma-operator
    for (i = 0, end = fullRowCount, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
      var row = table.table[i] || [];
      row = row.concat(fillerFor(row.length)); // fill to new width.
      if (minI <= i && i < minI + rowCount) {
        var pasteRow = cells[i - minI];
        row = ((): Array<Cell> => {
          let asc1, end1;
          const result1 = [];
          // eslint-disable-next-line benchlint/disallow-comma-operator
          for (j = 0, end1 = fullColCount, asc1 = 0 <= end1; asc1 ? j < end1 : j > end1; asc1 ? j++ : j--) {
            const tableCell = row[j];
            const evaluatedCell: EvaluatedCell | null =
              computedTable[i] && computedTable[i][j] ? computedTable[i][j] : null;
            const columnConstraint = columnConstraints && columnConstraints[j];
            const cellLocked = evaluatedCell?.locked || TableUtil.isColumnLocked(columnConstraint);
            const isHiddenMergedCell =
              evaluatedCell?.mergedBox &&
              (evaluatedCell.mergedBox.minI !== i || evaluatedCell.mergedBox.minJ !== j);

            // If we are preserving merged cells, then copy over the existing cell's
            // mergeColSpan and mergeRowSpan into the new pasted cell
            if (
              minJ <= j &&
              j < minJ + colCount &&
              !cellLocked &&
              (!preserveMergedCells || !isHiddenMergedCell)
            ) {
              const cell = {...relToAbsCell(pasteRow[j - minJ], {row: i, column: j})};
              if (preserveMergedCells) {
                if (tableCell.mergeColSpan) {
                  cell.mergeColSpan = tableCell.mergeColSpan;
                }
                if (tableCell.mergeRowSpan) {
                  cell.mergeRowSpan = tableCell.mergeRowSpan;
                }
              }
              const typeConvertedCell = getPasteTypeConvertedCell(cell, columnConstraint);
              result1.push(typeConvertedCell);
              tableOp.cells.push({row: i, column: j});
            } else {
              result1.push(row[j]);
            }
          }
          return result1;
        })();
      }
      result.push(row);
    }
    return result;
  })();

  const tableFieldDefaults = Object.keys(COLUMN_FIELD_DEFAULTS).reduce<Partial<Table>>((acc, field) => {
    acc[field as keyof typeof COLUMN_FIELD_DEFAULTS] = _.range(fullColCount).map((i) => {
      const defaultValue = COLUMN_FIELD_DEFAULTS[field as keyof typeof COLUMN_FIELD_DEFAULTS];
      const value =
        table[field as keyof typeof COLUMN_FIELD_DEFAULTS][i] != null
          ? table[field as keyof typeof COLUMN_FIELD_DEFAULTS][i]
          : defaultValue;
      return value;
      // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    }) as any;
    return acc;
  }, {});
  const newTable = reactUpdate(table, {
    $merge: {...table, ...tableFieldDefaults, table: newCells},
  });
  return {
    table: newTable,
    box: {minI, minJ, maxI: minI + rowCount - 1, maxJ: minJ + colCount - 1},
    tableOp,
  };
}

export default paste;

function __range__(left: number, right: number, inclusive: boolean): Array<number> {
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
